import { initDetailPageEffects, initTransitionArrival } from "./page-demo.js";
import { initHomeLogos } from "./home-logos.js";
import { initSiteMenu, syncSiteMenuCurrent } from "./site-menu.js";
import { createSpaApp } from "./spa-app.js";

const GA_MEASUREMENT_ID = "G-Q0JB5W73KD";

let contactHotspotRaf = 0;
let contactHotspotObserver = null;
const contactHotspotLoadBoundImages = new WeakSet();

function trackPageView(route) {
  if (typeof window.gtag !== "function" || !route) {
    return;
  }

  window.gtag("event", "page_view", {
    send_to: GA_MEASUREMENT_ID,
    page_title: route.title || document.title,
    page_path: window.location.pathname,
    page_location: window.location.href,
    language: route.locale || document.documentElement.lang,
  });
}

function initHomeVideo() {
  const homeVideo = document.querySelector(".home-hero__bg");
  if (!(homeVideo instanceof HTMLVideoElement)) {
    return;
  }

  const playbackRate = 0.72;
  const applyPlaybackRate = () => {
    homeVideo.playbackRate = playbackRate;
    homeVideo.defaultPlaybackRate = playbackRate;
  };

  applyPlaybackRate();
  homeVideo.addEventListener("loadedmetadata", applyPlaybackRate);
  homeVideo.addEventListener("play", applyPlaybackRate);
}

function getCoveredBox(containerRect, naturalWidth, naturalHeight) {
  if (!containerRect || !naturalWidth || !naturalHeight || containerRect.width <= 0 || containerRect.height <= 0) {
    return null;
  }

  const imageRatio = naturalWidth / naturalHeight;
  const containerRatio = containerRect.width / containerRect.height;
  let width;
  let height;

  if (containerRatio > imageRatio) {
    width = containerRect.width;
    height = width / imageRatio;
  } else {
    height = containerRect.height;
    width = height * imageRatio;
  }

  return {
    left: (containerRect.width - width) / 2,
    top: (containerRect.height - height) / 2,
    width,
    height,
  };
}

function getContainedBox(containerRect, naturalWidth, naturalHeight) {
  if (!containerRect || !naturalWidth || !naturalHeight || containerRect.width <= 0 || containerRect.height <= 0) {
    return null;
  }

  const imageRatio = naturalWidth / naturalHeight;
  const containerRatio = containerRect.width / containerRect.height;
  let width;
  let height;

  if (containerRatio > imageRatio) {
    height = containerRect.height;
    width = height * imageRatio;
  } else {
    width = containerRect.width;
    height = width / imageRatio;
  }

  return {
    left: (containerRect.width - width) / 2,
    top: (containerRect.height - height) / 2,
    width,
    height,
  };
}

function syncContactHotspots() {
  const visual = document.querySelector(".contact-visual");
  const image = document.querySelector(".contact-visual__image");
  const hotspots = document.querySelector(".contact-hotspots");

  if (!(visual instanceof HTMLElement) || !(image instanceof HTMLImageElement) || !(hotspots instanceof SVGSVGElement)) {
    contactHotspotObserver?.disconnect();
    contactHotspotObserver = null;
    return;
  }

  if (!image.complete || !image.naturalWidth || !image.naturalHeight) {
    if (!contactHotspotLoadBoundImages.has(image)) {
      contactHotspotLoadBoundImages.add(image);
      image.addEventListener("load", scheduleContactHotspotSync, { once: true });
    }
    return;
  }

  const visualRect = visual.getBoundingClientRect();
  const imageRect = image.getBoundingClientRect();
  const box = {
    left: imageRect.left - visualRect.left,
    top: imageRect.top - visualRect.top,
    width: imageRect.width,
    height: imageRect.height,
  };

  if (!box.width || !box.height) {
    return;
  }

  hotspots.style.left = `${box.left}px`;
  hotspots.style.top = `${box.top}px`;
  hotspots.style.width = `${box.width}px`;
  hotspots.style.height = `${box.height}px`;

  if ("ResizeObserver" in window) {
    if (!contactHotspotObserver) {
      contactHotspotObserver = new ResizeObserver(() => scheduleContactHotspotSync());
    }
    contactHotspotObserver.disconnect();
    contactHotspotObserver.observe(visual);
  }
}

function scheduleContactHotspotSync() {
  window.cancelAnimationFrame(contactHotspotRaf);
  contactHotspotRaf = window.requestAnimationFrame(syncContactHotspots);
}

function bindContactHotspotSync() {
  if (window.__magallanesContactHotspotsSyncBound) {
    return;
  }

  window.__magallanesContactHotspotsSyncBound = true;

  window.addEventListener("resize", scheduleContactHotspotSync, { passive: true });
  window.addEventListener("orientationchange", scheduleContactHotspotSync, { passive: true });
  scheduleContactHotspotSync();
}

initSiteMenu();
initTransitionArrival();
bindContactHotspotSync();

const spa = createSpaApp({
  onAfterRender: (route) => {
    initHomeVideo();
    initHomeLogos();
    initDetailPageEffects();
    initSiteMenu();
    syncSiteMenuCurrent();
    scheduleContactHotspotSync();
    trackPageView(route);
  },
});

spa.start();
